import { IContractorPropsPerOrigin } from 'config'
import { replaceNextLineToBr } from 'utils'

export function Welcome({ props }: { props: IContractorPropsPerOrigin }) {
  return (
    <div
      className="md:px-2"
      dangerouslySetInnerHTML={{ __html: replaceNextLineToBr(props.inputs.content.defaultValue) }}
    />
  )
}
